export function createModalService(eventBus) {
  return {
    show: (options) => {
      eventBus.emit("show", options);
    },
    hide: (options) => {
      eventBus.emit("hide", options);
    },
    hideAll: () => {
      eventBus.emit("hideAll", {});
    }
  };
}
